export enum EThresholdVisibility {
  FULL = 1,
}
